export default __webpack_public_path__ + "static/kv-584a9f34647f231b8fd255e66d57c1d6.jpg";